import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appKBoton]'
})
export class KBotonDirective implements OnInit{
  @Input() boton = 'primero';
  @Input() bold = false;
  @Input() backgroundColor: string;
  @Input() color: string;

  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    this.boldTxt();
    this.addColor();
    this.addColorText();
    switch (this.boton) {
      case 'primero':
        this.el.nativeElement.classList.add('btn-py', 'btn', 'btn-kb');
        break;
      case 'segundo':
        this.el.nativeElement.classList.add('btn-scd', 'btn', 'btn-kb');
        break;
      case 'tercero':
        this.el.nativeElement.classList.add('btn-tr', 'btn', 'btn-kb');
        break;
      case 'blanco':
        this.el.nativeElement.classList.add('btn-blanco', 'btn', 'btn-kb');
        break;
      case 'basico':
        this.el.nativeElement.classList.add('btn-basico', 'btn', 'btn-kb');
        break;
      case 'cuarto':
        this.el.nativeElement.classList.add('btn-fr', 'btn', 'btn-kb');
        break;
      case 'quinto':
        this.el.nativeElement.classList.add('btn-qn', 'btn', 'btn-kb');
        break;
      case 'sexto':
        this.el.nativeElement.classList.add('btn-sx', 'btn', 'btn-kb');
        break;
      default:
        break;
    }

  }
  public boldTxt = (): void => {
    if (this.bold) {
      this.el.nativeElement.style.fontWeight = '700';
    }
  }

  public addColor = () => {
    if (this.backgroundColor) {
      this.el.nativeElement.style.backgroundColor = this.backgroundColor;
      this.el.nativeElement.style.border = 'none';
    }
  }
  
  public addColorText = () => {
    if (this.color) {
      this.el.nativeElement.style.color = this.color;
    }
  }
}
